import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  output,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-link',
  templateUrl: './m-link.component.html',
  styleUrls: ['./m-link.component.scss'],
  imports: []
})
export class MLinkComponent implements OnChanges {
  @Input() link = '#';
  @Input() label = 'here';
  @Input() disabled = false;
  @Input() linkElement: 'a' | 'span' = 'a';
  @Input() styleClass = '';
  @Input() target = '_blank';

  readonly linkClick = output<string>();

  ngOnChanges(changes: SimpleChanges) {
    this.label = changes['label']?.currentValue || this.label;
  }

  publishLinkClick() {
    this.linkClick.emit(this.link);
  }
}
